import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

// ------------------ STATE INTERFACE ------------------
interface ResetLoginFailedState {
    data: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "reset-login-failed" | null;
}





// ------------------ INITIAL STATE ------------------
const initialState: ResetLoginFailedState = {
    data: null,
    loading: "idle",
    error: null,
    action: null,
};

// ------------------ ASYNC THUNK ------------------
export const ResetLoginFailed = createAsyncThunk(
    "employee/reset-login-failed",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(
                API_URLS.EMPLOYEES.RESET_LOGIN_FAILED,
                payload
            );
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// ------------------ SLICE ------------------
const ResetLoginSlice = createSlice({
    name: "reset-login-failed",
    initialState,
    reducers: {
        resetAll: (state) => {
            state.data = null;
            state.error = null;
            state.loading = "idle";
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(ResetLoginFailed.pending, (state) => {
            state.loading = "pending";
            state.data = null;
            state.error = null;
            state.action = "reset-login-failed";
        });

        builder.addCase(ResetLoginFailed.fulfilled, (state, action) => {
            state.loading = "fulfilled";
            state.data = action.payload;
            state.error = null;
            state.action = "reset-login-failed";
        });

        builder.addCase(ResetLoginFailed.rejected, (state, action) => {
            state.loading = "rejected";
            state.data = null;
            state.error = action.payload as string;
            state.action = "reset-login-failed";
        });
    },
});

// ------------------ EXPORTS ------------------
export const { resetAll } = ResetLoginSlice.actions;
export default ResetLoginSlice.reducer;
